import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "../CartContext";
import AuthContext from "../AuthContext";
import { getData } from "../Api";
import { SettingsContext } from "../SettingsContext";

const NavigationBar = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const { settings } = useContext(SettingsContext);
  const [categories, setCategories] = useState([]);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { cart } = useContext(CartContext);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getData("/categories");

        if (response.success) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const isActive = (path) => (location.pathname === path ? "active" : "");

  const toggleNavbar = () => setIsNavbarOpen((prev) => !prev);

  return (
    <>
      {/* Top Bar */}
      <div className="row">
        <div className="top-bar">
          Premium Colouring Books | Educational Designs | Stress Relief for Adults | Order Today!
        </div>
      </div>

      <header className="row px-sm-5">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Logo */}
            <Link className="navbar-brand order-1" to="/">
              <img src="/assets/img/logo.png" alt="Logo" height="70" />
            </Link>

            {/* Toggle Button */}
            <button
              className="navbar-toggler order-md-3 order-4 menu_btn"
              type="button"
              aria-expanded={isNavbarOpen}
              onClick={toggleNavbar}
            >
              <i
                className={`fa-solid fa-bars text-success ${
                  isNavbarOpen ? "fa-times" : "fa-bars"
                }`}
              ></i>
            </button>

            {/* Navbar Links */}
            <div
              className={`collapse navbar-collapse order-md-2 order-3 ${
                isNavbarOpen ? "show" : ""
              }`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mx-auto">
                <li className="nav-item">
                  <Link className={`nav-link ${isActive("/")}`} to="/">
                    Home
                  </Link>
                </li>

                {/* Dynamic Categories Dropdown */}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    All Products
                  </Link>
                  <ul className="dropdown-menu">
                    {categories.map((category) => (
                      <li key={category.id}>
                        <Link
                          className={`dropdown-item ${isActive(
                            `/category/${category.slug}`,
                          )}`}
                          to={`/category/${category.slug}`}
                        >
                          {category.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/our-story")}`}
                    to="/our-story"
                  >
                    About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/reviewus")}`}
                    to="/reviewus"
                  >
                    Review Us
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={` nav-link ${isActive("/complaint")}`}
                    to="/complaint"
                  >
                    Complaint
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/contact")}`}
                    to="/contact"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Icons Section */}
            <div className="icons d-flex align-items-center order-md-4 order-2">
              {user ? (
                <div
                  className="dropdown"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}
                >
                  <button
                    className="btn btn-light dropdown-toggle"
                    id="userDropdown"
                  >
                    👤 {user.name}
                  </button>
                  {isDropdownOpen && (
                    <ul
                      className="dropdown-menu show position-absolute "
                      aria-labelledby="userDropdown"
                    >
                      <li>
                        <Link
                          className={` nav-link55 dropdown-item ${isActive(
                            "/my-profile",
                          )}`}
                          to="/my-profile"
                        >
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` nav-link55 dropdown-item ${isActive(
                            "/my-orders",
                          )}`}
                          to="/my-orders"
                        >
                          My Orders
                        </Link>
                      </li>

                      <li className="ps-3">
                        <button className="dropdown-item" onClick={logout}>
                          Logout
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              ) : (
                <Link to="/login">
                  <i className="fa-solid fa-user"></i>
                </Link>
              )}
              {/* <Link to="/trackOrder">
                <i className="fa-solid fa-truck"></i>
              </Link> */}
              <Link to="/cart" className="position-relative">
                <i className="fa-solid fa-bag-shopping"></i>
                <span className="cart-badge">{cart.length}</span>{" "}
                {/* Fix applied */}
              </Link>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default NavigationBar;
